import LargeCabNoFreeBoxModal from './LargeCabNoFreeBoxModal';

export default LargeCabNoFreeBoxModal;
